export default "__VITE_ASSET__bPTGqj08__"